/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100083 仕入先マスタ出力
 */
import { Box } from "@mui/material";
import {
  B100080ShireNmFrom,
  B100080ShireNmTo,
  B100083ExcelRequest,
  B100083GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000170 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  shireCdFrom: string;
  shireNmFrom: string;
  shireCdTo: string;
  shireNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  shireCdFrom: "",
  shireNmFrom: "",
  shireCdTo: "",
  shireNmTo: "",
};

const focusId = "B100083";

export const B100083 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100083ExcelRequest = {
      shireCdFrom: fields.shireCdFrom!,
      shireCdTo: fields.shireCdTo!,
    };

    B100083GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100083_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="仕入先マスタ出力"
        gridTemplateColumns="7rem 6rem 15rem 1rem 6rem 15rem 5rem"
      >
        <SText gridColumn="span 7">　</SText>

        <SLabel>仕入先コード</SLabel>
        <SNumberField
          name="shireCdFrom"
          code
          size={6}
          {...register(1)}
          dialog={<B000170 deljogaiKbn="1" />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCdFrom", data.shireCd);
            methods.setValue("shireNmFrom", data.shireNm1);
          }}
          onBlur={() => B100080ShireNmFrom(methods, navigate, setMsg)}
        />
        <STextField name="shireNmFrom" disabled />

        <SText>～</SText>
        <SNumberField
          name="shireCdTo"
          code
          size={6}
          {...register(2)}
          dialog={<B000170 deljogaiKbn="1" />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCdTo", data.shireCd);
            methods.setValue("shireNmTo", data.shireNm1);
          }}
          onBlur={() => B100080ShireNmTo(methods, navigate, setMsg)}
        />
        <STextField name="shireNmTo" disabled />
        <Box />

        <SText gridColumn="span 7">　</SText>
        <SText gridColumn="span 7">　</SText>
        <SText gridColumn="span 7">　</SText>

        <Box gridColumn="span 5" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(3)}
          dialog={
            <SConfirmDialog
              title="仕入先マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
